import { Field } from "@base-ui-components/react/field";
import { Icon } from "~components/ui";
import { cn } from "~utils";
import { Button } from "./button";
import { useFilterEvents } from "./filter-events-context-provider";
import { useSectionEventTranslations } from "./translations-section-events-context-provider";

function SearchEvents() {
  const { t } = useSectionEventTranslations();
  const { handleSearchEvents, searchQuery, clearSearchEvents } =
    useFilterEvents();

  const onClick = () => {
    clearSearchEvents();
  };

  return (
    <Field.Root className="relative flex h-xl w-full max-w-lg items-center">
      <Field.Control
        placeholder={t.searchPlaceholder}
        type="search"
        className="focus:-outline-offset-1 h-full w-full rounded-md border border-secondaryButton-text bg-[transparent] pr-lg-xl pl-sm hover:border-secondaryButton-hover focus:bg-others-white focus:outline focus:outline-2 focus:outline-secondaryButton-hover"
        onValueChange={handleSearchEvents}
        value={searchQuery}
      />
      <Button
        className={cn(
          "absolute right-2xs p-2xs text-secondaryButton-text",
          searchQuery &&
            "focus:-outline-offset-1 rounded-sm focus:outline focus:outline-2 focus:outline-secondaryButton-hover",
        )}
        onClick={onClick}
      >
        <Icon name={searchQuery ? "X" : "MagnifyingGlass"} size="24" />
      </Button>
    </Field.Root>
  );
}

export { SearchEvents };
